var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "row border-radius bg-white padding-flex mb-1" },
    [
      _c("div", { staticClass: "col-md-12 estate-energy-data" }, [
        _c("div", { staticClass: "row" }, [
          _vm._m(0),
          _vm._v(" "),
          _c("div", { staticClass: "col" }, [
            _c("span", {
              domProps: { innerHTML: _vm._s(_vm.trans("labels.desc_tag")) }
            })
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-auto" }, [
      _c("img", { attrs: { src: "/img/logo/logo_tag.svg", width: "60" } })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }